import { render, staticRenderFns } from "./video-play.vue?vue&type=template&id=f698dd80&scoped=true&"
import script from "./video-play.vue?vue&type=script&lang=js&"
export * from "./video-play.vue?vue&type=script&lang=js&"
import style0 from "./video-play.vue?vue&type=style&index=0&id=f698dd80&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f698dd80",
  null
  
)

export default component.exports